var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvoHeaderDarkicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2486 3.45917C12.796 3.45917 13.321 3.67662 13.7081 4.06369C14.0952 4.45077 14.3126 4.97575 14.3126 5.52315V11.0271C14.3126 11.5745 14.0952 12.0995 13.7081 12.4866C13.321 12.8736 12.796 13.0911 12.2486 13.0911H8.47365L5.36868 15.1551V13.0911H3.9927C3.44529 13.0911 2.92031 12.8736 2.53324 12.4866C2.14617 12.0995 1.92871 11.5745 1.92871 11.0271V5.52315C1.92871 4.97575 2.14617 4.45077 2.53324 4.06369C2.92031 3.67662 3.44529 3.45917 3.9927 3.45917H12.2486Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.88563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36865 6.89914H10.8726ZM5.36865 9.65112H8.77883Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36865 6.89914H10.8726M5.36865 9.65112H8.77883",
    stroke: "#151515",
    strokeWidth: 1.15132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8476 9.86646C11.4982 9.86646 11.163 9.99055 10.9159 10.2114C10.6688 10.4323 10.5299 10.7319 10.5299 11.0443V14.1852C10.5299 14.4976 10.6688 14.7972 10.9159 15.018C11.163 15.2389 11.4982 15.363 11.8476 15.363L13.6785 15.363L15.8747 16.5409V15.363H16.7531C17.1026 15.363 17.4377 15.2389 17.6849 15.018C17.932 14.7972 18.0708 14.4976 18.0708 14.1852V11.0443C18.0708 10.7319 17.932 10.4323 17.6849 10.2114C17.4377 9.99055 17.1026 9.86646 16.7531 9.86646L11.8476 9.86646Z",
    fill: "white",
    stroke: "#151515",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 11.8764H12.5544ZM15.832 13.5152H13.3738Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 11.8764H12.5544M15.832 13.5152H13.3738",
    stroke: "#151515",
    strokeWidth: 0.748969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvoHeaderDarkicon);
export default __webpack_public_path__ + "static/media/convo-header-darkicon.c277d41c4f2ca006569a8fbabd8482e0.svg";
export { ForwardRef as ReactComponent };